(function () {
  let deduping = false;

  function consolidateCartDuplicates() {
    if (deduping) return;
    deduping = true;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const items = cart.items;
        const seen = {};
        const updates = {};
        let hasDuplicates = false;

        items.forEach(item => {
          const key = String(item.variant_id);
          if (seen[key] !== undefined) {
            hasDuplicates = true;
            updates[seen[key]] = (updates[seen[key]] || items.find(i => i.key === seen[key]).quantity) + item.quantity;
            updates[item.key] = 0;
          } else {
            seen[key] = item.key;
          }
        });

        if (hasDuplicates) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          }).then(() => {
            // Intenta múltiples eventos para refrescar el drawer de Shrine Pro
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('theme:cart:open'));
            window.dispatchEvent(new CustomEvent('cart:refresh'));
          });
        }
      })
      .finally(() => {
        deduping = false;
      })
      .catch(err => console.error('Cart dedup error:', err));
  }

  // Intercepta TODAS las llamadas fetch a /cart/add
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    const result = originalFetch.apply(this, args);
    if (url.includes('/cart/add')) {
      result.then(() => {
        setTimeout(consolidateCartDuplicates, 300);
        setTimeout(consolidateCartDuplicates, 800);
        setTimeout(consolidateCartDuplicates, 1500);
      });
    }
    return result;
  };

  // Intercepta XMLHttpRequest también (por si el tema usa XHR en vez de fetch)
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (url && url.includes('/cart/add')) {
      this.addEventListener('load', () => {
        setTimeout(consolidateCartDuplicates, 300);
        setTimeout(consolidateCartDuplicates, 800);
      });
    }
    return originalOpen.apply(this, [method, url, ...rest]);
  };
})();
